import { WordCountConfig } from '@ckeditor/ckeditor5-word-count'

export * from '@ckeditor/ckeditor5-word-count'

declare module '@ckeditor/ckeditor5-core/src/editor/editorconfig' {
  interface EditorConfig {
    wordCount?: WordCountConfig
  }
}
